import moment from "moment";
import _ from "lodash";

export function convertToTimezone(date, UTC, dateOpt) {
    const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = Intl.NumberFormat().resolvedOptions().locale;

    if (isNaN(date.getTime())) {
        return "Invalid Date";
    }

    // override timezone to Europe/Isle_of_Man if system timezone is Unknown
    let timezone = systemTimezone.includes("Unknown") ? "Europe/Isle_of_Man" : systemTimezone;

    let dateOptions = {
        dateStyle: "short",
    };

    if (dateOpt) {
        dateOptions = dateOpt;
    }

    dateOptions["timeZone"] = UTC ? "UTC" : timezone;

    let timeOptions = {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: UTC ? "UTC" : timezone,
    };

    let d = date.toLocaleDateString(locale, dateOptions);
    let time = moment(date).format(`HH:mm:ss`);
    const tz = date
        .toLocaleDateString(locale, { timeZoneName: "short", ...timeOptions })
        .split(" ")
        .pop();

    if (UTC) {
        time = moment(date).utc().format(`HH:mm:ss`);
    }

    // if dateOpt passed it will usually be if different date format is required, return formatted d instead
    // eg. to get: "October 25, 2024, 3:45 PM UTC"
    // you pass dateOpt: { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" }
    if (dateOpt) {
        // if in dateOpt there is no hour or minute passed do not include timezone at the end
        const includeTz = _.get(dateOpt, "hour") || _.get(dateOpt, "minute");
        if (includeTz) {
            d = date.toLocaleTimeString(locale, dateOptions);
            return `${d} ${tz}`;
        }
        return d;
    }

    return d + " " + time + " " + tz;
}

export const convertTsToMilliseconds = (ts) => {
    if (!_.isNumber(ts)) {
        return undefined; // this will make a date invalid
    }

    // If ts has less digits than 10, convert to milliseconds
    if (ts < 9999999999) {
        return ts * 1000;
    }
    return ts;
};

export function formatHumanDate(timestamp, convertToUtc) {
    const dateTime = new Date(convertTsToMilliseconds(timestamp));

    return convertToTimezone(dateTime, convertToUtc, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
    });
}
